import "./Home.module.css";
import BlipoliNavigation from "@/reusable_sections/Header";
import ElevatedRealEstateStrategy from "./sections/ElevatedRealEstateStrategy";
import FifteenYearsOfJoyfulCelebrations from "./sections/FifteenYearsOfJoyfulCelebrations";
import HafizalardaKalanlar from "./sections/HafizalardaKalanlar";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <BlipoliNavigation />
      <ElevatedRealEstateStrategy />
      <FifteenYearsOfJoyfulCelebrations />
      <HafizalardaKalanlar />
      <Footer />
    </div>;
}